import { useCurrentUser } from '@mp/hooks';

type UseUploadSsnProps = {
  isAssignmentW2: boolean;
  assignmentNeedsItemUrl: boolean;
};

export const useUploadSsn = ({ isAssignmentW2, assignmentNeedsItemUrl }: UseUploadSsnProps) => {
  const { currentUser } = useCurrentUser();
  // @ts-ignore
  const hasItemUrl = currentUser?.professional?.has_item_url;
  const hasItem = currentUser?.professional?.has_item;
  const hasUploadedSSN = hasItem || hasItemUrl;
  const requiresItemImage = currentUser?.professional?.required_item_image;

  const requiredItem = isAssignmentW2 && !hasItem && !hasItemUrl;
  const requireImage = assignmentNeedsItemUrl && !hasItem && !hasItemUrl;
  const mustUploadSSN = requireImage || requiredItem;

  return {
    mustUploadSSN,
    hasUploadedSSN,
    requiresItemImage,
  };
};
